import axiosInstance from "../Config/axiosConfig";

const getHeaders = () => {
  const accessToken = localStorage.getItem("accessToken");
  const storedDeviceId = localStorage.getItem("deviceId");
  const storedUserIp = localStorage.getItem("userIp");

  return {
    Authorization: `Bearer ${accessToken}`,
    ...(storedDeviceId && { UserDevice: storedDeviceId }),
    ...(storedUserIp && { UserIPAddress: storedUserIp }),
    "Content-Type": "application/json",
  };
};

export const fetchStudents = async () => {
  try {
    const response = await axiosInstance.get("/Admin/get-students", {
      headers: getHeaders(),
    });

    // Handle different response formats
    let studentsData = [];
    if (Array.isArray(response.data)) {
      studentsData = response.data;
    } else if (response.data && Array.isArray(response.data.students)) {
      studentsData = response.data.students;
    } else if (response.data && response.data.data) {
      studentsData = Array.isArray(response.data.data) ? response.data.data : [response.data.data];
    } else {
      studentsData = [response.data]; // Wrap single object in array
    }

    return studentsData;
  } catch (error) {
    console.error("Error fetching students:", error);
    throw error;
  }
};